import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";

import { getHubspotStatusThunk } from "../../store/effects/hubspot/status";

const useHubspotStatusCall = (): void => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(getHubspotStatusThunk());
    });
};

export default useHubspotStatusCall;
